var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66663 12.6668C7.11463 12.6668 6.66663 12.2188 6.66663 11.6668C6.66663 11.1148 7.11463 10.6668 7.66663 10.6668C8.21863 10.6668 8.66663 11.1148 8.66663 11.6668C8.66663 12.2188 8.21863 12.6668 7.66663 12.6668ZM10.5406 6.75143C10.3346 7.08143 9.94329 7.4521 9.36596 7.8641C8.43196 8.55476 8.45729 8.7081 8.45729 9.33343H6.81929C6.81929 8.84476 6.80863 8.46943 7.07263 8.01276C7.24129 7.7201 7.55063 7.40876 7.99996 7.07943C8.53929 6.6941 9.06329 6.32279 9.06329 5.67612C9.06329 5.07012 8.54463 4.85412 7.93863 4.85412C7.32063 4.85412 6.61597 5.05612 5.82463 5.46012L5.15063 4.10679C6.58863 3.30079 8.85796 2.93612 10.0986 3.94612C11.0093 4.68812 11.0146 5.99279 10.5406 6.75143Z",
    fill: "#442E83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#442E83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpTerms);
export default __webpack_public_path__ + "static/media/help-terms.e895fabb3dc401df6a4a38fde9e10e03.svg";
export { ForwardRef as ReactComponent };